import {
  Component,
  effect,
  EventEmitter,
  forwardRef,
  input,
  InputSignal,
  Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'stc-apps-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterDropdownComponent),
      multi: true,
    },
  ],
})
export class FilterDropdownComponent implements ControlValueAccessor {
  dropdownOptions: InputSignal<{ label: string; value: any }[]> = input<
    { label: string; value: any }[]
  >([]);
  placeholder: InputSignal<string> = input('');
  selectedValue: InputSignal<any> = input(null);
  class: InputSignal<any> = input('');
  panelStyleClass = input<string>('');
  enableFilter: InputSignal<boolean> = input<boolean>(true);
  @Output() valueChange = new EventEmitter();
  @Output() dropdownShow = new EventEmitter();
  value: any;
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor() {
    effect(() => {
      this.value = this.selectedValue();
    });
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onValueChange(event: any) {
    this.value = event;
    this.onChange(event);
    this.onTouched();
    this.valueChange.emit(event);
  }
}
